export default __webpack_public_path__ + "static/media/cup.18c2b5ab.png";